import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Observable } from 'rxjs';
import { AppComponent } from './app.component';
import { UserService } from './services/user.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { AppConfigService } from './services/app-config.service';

@Component({
    selector: 'app-menu',
    template: `
        <ul class="layout-menu">
            <li app-menuitem *ngFor="let item of model; let i = index;" [item]="item" [index]="i" [root]="true"></li>
        </ul>
        
    `
})
export class AppMenuComponent implements OnInit {

    model!: MenuItem[];

    isLoggedIn(): boolean {
        return this.userService.isLoggedIn()
    }

    allocationVisible: boolean
    sdeVisible: boolean = true

    constructor(public app: AppComponent, private appConfigService: AppConfigService, private userService: UserService) { }

    ngOnInit() {
        this.createModel()
    }

    getOrigin(): string {
        return window.location.origin;
    }

    createModel() {
        const apps = this.appConfigService.getApps();
        this.model = [
            {
                label: 'Applications',
                icon: 'pi pi-fw pi-th-large', 
                items: apps.map((app) => ({
                    label: app.title,
                    icon: app.icon || 'pi pi-fw pi-cog', 
                    routerLink: [app.url],
                })),
            }, {
                label: 'Swaggers',
                icon: 'pi pi-fw pi-sitemap', 
                items: [
                    { label: 'Auth', icon: 'pi pi-fw pi-book', routerLink: [this.getOrigin() + '/core-auth/swagger'] },
                    { label: 'Forecasting', icon: 'pi pi-fw pi-book', routerLink: [this.getOrigin() + '/fcst-api/swagger'] },
                ],
            }
        ];
    }
}
